<template>
<div class="container-fluid">
  <h1>Apps <i class="fa fa-plus-circle h1-plus" aria-hidden="true" @click="goCreatePage"></i>
  <span class="platforms-options">
    <select @change="selectOnChanged">
      <option value="0">All Platforms</option>
      <option value="1">iOS</option>
      <option value="2">Android</option>
    </select>
  </span>
  </h1>
  <hr/>
  <app-loading :className="isLoading ? 'loading' : ''"></app-loading>
  <div class="row appRow">
      <div class="col-4" v-for="app in apps" :key="app.id" @click="viewDetails(app)" >
        <div class="row innerRow">
          <img :id="app.id" :src="app.thumbnail"
                class="thumbnail"
                @error="altImg" width="100px" height="100px"/>
          <div class="col app-name-square">
            <span class="app-name">{{app.name}}</span><br/>
            <i :class="getOSText(app.platform).icon"></i><span style="padding-left: 10px">{{getOSText(app.platform).platform}}</span>
          </div>
        </div>
      </div>
  </div>
</div>
</template>
<script>
import { getPreviousVersion } from '@/helpers/appstore.js';
import Loading from '@/components/Loading';

export default {
  data () {
    return {
      apps: [],
      appsFirst: [],
      appsFiltered: [],
      altImage: require('@/assets/notavailable.png'),
      isLoading: false,
      routeAppsDetail: 'apps2-details-2',
      file: null,
      appVersion: {}
    };
  },
  methods: {
    viewDetails (app) {
      let selectedApp = app;
      if (selectedApp.noVersion) {
        alert('WARNING: This app is not ready for download since there is no version attached to it. Thank you.');
      }
      sessionStorage.setItem('app', JSON.stringify(selectedApp));
      console.log(selectedApp);
      this.$router.push({ name: this.routeAppsDetail, params: { id: selectedApp.id } });
    },
    altImg (e) {
      e.target.src = this.altImage;
    },
    getUrlToApp (id) {
      let path = this.$router.resolve({ name: this.routeAppsDetail, params: { id: id } }).href;
      return window.location.origin + path;
    },
    getOSText (os) {
      return 'ios' === os.toLowerCase() ? { platform: 'iOS', icon: 'fa fa-apple' } : { platform: 'Android', icon: 'fa fa-android' };
    },
    goCreatePage () {
      this.$router.push({ name: 'apps2-create-2' });
    },
    async getAppList () {
      this.isLoading = true;
      sessionStorage.removeItem('app');
      const firstResponse = await this.axios.get(process.env.VUE_APP_URL_UNIVERSAL_API + '/app-store/app?page=1');
      const appStoreData = firstResponse.data.data.appStores;
      for (const appData of appStoreData) {
        let thumbnail = '';
        let noVersion = false;
        this.apps.push({
          id: appData.id,
          name: appData.name,
          description: appData.description,
          thumbnail: thumbnail,
          platform: appData.platform,
          noVersion: noVersion
        });
      }
      this.isLoading = false;
      this.appsFiltered = [];
      for (const app of this.apps) {
        let versionThumbnail = await this.getPreviousThumbnail(app);
        this.appsFiltered.push({
          id: app.id,
          name: app.name,
          description: app.description,
          thumbnail: versionThumbnail.thumbnail,
          platform: app.platform,
          noVersion: versionThumbnail.noVersion
        });
        document.getElementById(app.id).src = versionThumbnail.thumbnail;
      }
      this.apps = this.appsFiltered;
      this.appsFirst = this.apps;
    },
    async getPreviousThumbnail (appData) {
      const secondResponse = await this.axios.get(process.env.VUE_APP_URL_UNIVERSAL_API + `/app-store/app/${appData.id}/version`);
      let versions = secondResponse.data.data.versions;
      let currentVersionResults = versions.filter(value => true === value.isCurrent);
      let currentVersion = currentVersionResults[0];
      let currentVersionIndex = versions.findIndex(value => true === value.isCurrent);
      let thumbnail = '';
      let noVersion = true; // Has version/no version indicator
      if (currentVersionResults.length > 0 || versions.length > 0) {
        noVersion = false;
      }
      if (0 === currentVersionResults.length) {
        currentVersion = versions[0];
      }
      let previousVersion = getPreviousVersion(currentVersionIndex, currentVersion, versions);
      thumbnail = previousVersion ? previousVersion.thumbnail : '';
      return { noVersion: noVersion, thumbnail: thumbnail };
    },
    iosApps (apps) {
      return apps.filter(function (app) {
        return 'ios' === app.platform.toLowerCase().trim();
      });
    },
    androidApps (apps) {
      return apps.filter(function (app) {
        return 'android' === app.platform.toLowerCase().trim();
      });
    },
    selectOnChanged (event) {
      let selectedOS = event.target.value;
      switch (selectedOS) {
        case '1':
          this.appsFiltered = this.appsFirst.filter(function (app) {
            return 'ios' === app.platform.toLowerCase().trim();
          });
          this.apps = this.appsFiltered;
          break;
        case '2':
          this.appsFiltered = this.appsFirst.filter(function (app) {
            return 'android' === app.platform.toLowerCase().trim();
          });
          this.apps = this.appsFiltered;
          break;
        default:
          this.apps = this.appsFirst;
          break;
      }
    }
  },
  mounted () {
    document.title = 'Admin Console: App Store';
    this.getAppList();
  },
  components: {
    'app-loading': Loading
  }
};
</script>
<style>
  .appRow {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .thumbnail {
    border-radius: 24px;
  }
  .main {
    background-color: #fff;
  }
  .innerRow {
    height: 117px;
    border-bottom: 1px solid rgba(0,0,0,0.1);
    margin-bottom: 16px;
    cursor: pointer;
  }
  .h1-plus {
    color: #0070c9;
    cursor: pointer;
  }
  .h1-small {
    font-size: small;
  }
  .app-name {
    font-weight: bold;
  }
  .app-name-square {
    padding-top: 30px;
  }
  .options-icon {
    font-size: medium;
    margin-bottom: 10px;
    color: #f2f2f2;
    margin-left: 10px;
  }
  .icon-option-color {
    color: #0070c9;
  }
  .search-icon {
    color: #0070c9;
    float: right;
  }
  .platforms-options {
    float: right;
  }
  .platforms-options select {
    color: #0070c9;
    font-size: small;
    font-weight: 700;
    margin-top: 0px;
    margin-left: 20px;
    border: none;
  }
  .platforms-options select:focus {
    outline: none;
  }

</style>
